<template>
  <div class="member-item" v-if="item">
    <div class="item-title">
      {{ item.title }}
    </div>
    <div class="item-owner">
      <template v-if="item.owner"> Owner: {{ item.owner.fullName }} </template>
      <template v-else>Owner: -</template>
    </div>
    <div
      class="item-image"
      :style="{
        'background-image': item.thumbnailUrl
          ? `url(${item.thumbnailUrl})`
          : null,
      }"
    ></div>
    <div class="item-details">
      <div class="last-updated">
        Last updated {{ getReadableDateTime(item.updatedAt) }}
      </div>
      <div class="addtional-tools">
        <div class="send-message-button">
          <img :src="icons.newMessageIcon" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import newMessageIcon from "@/assets/images/icons/ew-icon_new-message.svg";

export default {
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      icons: { newMessageIcon },
    };
  },
  methods: {
    getReadableDateTime(date) {
      return moment(date).fromNow();
    },
  },
};
</script>

<style lang="scss" scoped>
.member-item {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  color: #58595b;

  .item-title {
    padding: 5px;
    color: white;
    background-color: var(--color-blue-sky);
    font-size: 12px;
  }

  .item-owner {
    font-size: 10px;
    padding: 5px;
  }

  .item-image {
    width: 100%;
    height: 0;
    padding-bottom: 75%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  .item-details {
    padding: 5px;
  }

  .last-updated {
    font-size: 10px;
    color: #b9b9b9;
  }

  .addtional-tools {
    display: flex;
    margin-top: 10px;
    margin-left: -5px;

    .send-message-button {
      flex: 0 0 auto;
      cursor: pointer;

      img {
        width: 30px;
        height: 23px;
      }
    }
  }
}
</style>